// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"268":"Home","786":"TermsOfService"}[chunkId] + "." + {"268":"6f41ef64","786":"16ccc2e4"}[chunkId] + ".chunk.css";
};